import axios from 'axios';
import { AxiosResponse } from 'axios';
import { Store } from 'vuex';
import VueRouter from 'vue-router';
import TranslationService from '@/shared/service/translation.service';
import { IAccount } from '@/shared/model/account.model';

export default class AccountService {
  constructor(private store: Store<any>, private translationService: TranslationService, private router: VueRouter) {
    this.init();
  }

  public init(): void {}

  public retrieveAccount(): void {
    this.store.commit('authenticate');
    axios
      .get(this.getAccountApiUrl())
      .then(response => {
        const account: IAccount = response.data;
        if (account) {
          this.store.commit('authenticated', account);
        } else {
          this.store.commit('logout');
          this.router.push('/');
        }
        this.translationService.refreshTranslation(this.store.getters.currentLanguage);

        if (account.loginMethod == 'AUTO' && !account.firstLogin) {
          this.router.push('/first-login');
        }
      })
      .catch(() => {
        this.store.commit('logout');
      });
  }

  public hasAnyAuthority(authorities: any): boolean {
    if (typeof authorities === 'string') {
      authorities = [authorities];
    }
    if (!this.authenticated || !this.userAuthorities) {
      return false;
    }

    for (let i = 0; i < authorities.length; i++) {
      if (this.userAuthorities.includes(authorities[i])) {
        return true;
      }
    }

    return false;
  }

  private get authenticated(): boolean {
    return this.store.getters.authenticated;
  }

  private get userAuthorities(): any {
    return this.store.getters.account.authorities;
  }

  public retrieveAccountPromise(): Promise<AxiosResponse> {
    this.store.commit('authenticate');
    return axios.get(this.getAccountApiUrl());
  }

  public retrieveAccountSuccess(account: IAccount): void {
    if (account) {
      this.store.commit('authenticated', account);
    } else {
      this.store.commit('logout');
      this.router.push('/');
    }

    if (account.loginMethod == 'AUTO' && this.store.getters.showFirstLogin) {
      this.router.push('/first-login');
    }
  }

  public retrieveAccountFailure(): void {
    this.store.commit('logout');
  }

  private getAccountApiUrl(): string {
    const urlParams = new URLSearchParams(window.location.search);
    let client_id = urlParams.get('client_id');

    if (client_id == null) {
      const loginQuery = this.store.getters.loginQuery;
      if (loginQuery) {
        client_id = loginQuery.client_id;
      }
    }

    let accountUrl = 'api/account';
    if (client_id) {
      accountUrl = accountUrl + '?client_id=' + client_id;
    }

    return accountUrl;
  }
}
